import 'firebase/auth';

import firebase from 'firebase/app';

const config = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
};

if (!firebase.length) {
  firebase.initializeApp(config);
}

const auth = firebase.auth();
const { FacebookAuthProvider, GoogleAuthProvider } = firebase.auth;

const getToken = async () => {
  const token = await auth.currentUser.getIdToken();
  return token;
};

export {
  auth,
  FacebookAuthProvider,
  GoogleAuthProvider,
  getToken,
};
